import api from './api';
import i18n from '@/plugins/i18n';

const state = {
	metrics: [],
	totalRecords: 0,
	selectedMetric: null,
	loading: false,
	error: null,
};

const getters = {
	allMetrics: (state) => {
		return state.metrics;
	},
	totalRecords: (state) => {
		return state.totalRecords;
	},
	selectedMetric: (state) => {
		return state.selectedMetric;
	},
	isLoading: (state) => {
		return state.loading;
	},
	error: (state) => {
		return state.error;
	},
};

const mutations = {
	SET_LOADING(state, value) {
		state.loading = value;
	},
	SET_ERROR(state, error) {
		state.error = error;
	},
	SET_METRICS(state, { data, totalRecords }) {
		state.metrics = data;
		state.totalRecords = totalRecords;
	},
	SET_SELECTED_METRIC(state, metric) {
		state.selectedMetric = metric;
	},
	CLEAR_METRICS(state) {
		state.metrics = [];
		state.totalRecords = 0;
	},
};

const actions = {
	async fetchMetrics({ commit }, filters = {}) {
		commit('SET_LOADING', true);
		commit('SET_ERROR', null);
		try {
			const { data } = await api.getMetrics(filters);
			commit('SET_METRICS', { data: data.data, totalRecords: data.pagination.totalRecords });
		} catch (error) {
			const msg = error?.response?.data?.message || i18n.t('performance_metrics.error_fetch_all');
			commit('SET_ERROR', msg);
			throw error;
		} finally {
			commit('SET_LOADING', false);
		}
	},

	clearMetrics({ commit }) {
		commit('CLEAR_METRICS');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
